<div class="p-l-10 p-r-10 p-t-16 p-b-16">

    <div class="flex flex-middle flex-justify-between">

        <h3 class="h3"
            *iCms="'title' of content; skipEmpty: true"></h3>

        <button class="bg-col-5 b-radius-max flex flex-middle flex-justify-center"
                [style.height.rem]="2.5"
                [style.width.rem]="2.5"
                role="button"
                aria-label="Close"
                (click)="close()">
            <i class="inline-flex icon-close"
               aria-hidden="true"></i>
        </button>
    </div>

    <p class="p2 col-12 m-t m-b"
       *iCms="'description' of content; skipEmpty: true"></p>

    <p class="p1 m-t-7 m-b-3">
        {{'Deposit %' | translate}}
    </p>

    <input-wrap class="w-12 m-b"
                [messages]="{required: 'Please select deposit'}">
        <select class="input"
                name="v12_deposit_value"
                [muiInput]="('Deposit %'| translate)"
                [(ngModel)]="depositOptionValue"
                required>
            <option value=""
                    selected
                    disabled>{{'Deposit %' | translate}}</option>
            @for (depositOption of depositOptions; track trackByDepositValue($index, depositOption)) {
            <option [value]="depositOption.value">{{depositOption.title}}</option>
            }
        </select>
    </input-wrap>

    <p class="p1 m-t-2 m-b-3">
        {{'Package Plan' | translate}}
    </p>

    <input-wrap class="w-12 m-b"
                [messages]="{required: 'Please select package plan'}">
        <select class="input"
                name="v12_package_plan"
                [muiInput]="('Package Plan'| translate)"
                [(ngModel)]="packOptionId"
                required>
            <option value=""
                    selected
                    disabled>{{'Package Plan' | translate}}</option>
            @for (packOption of packOptions; track trackByPackId($index, packOption)) {
            <option [value]="packOption.id">{{packOption.title}}</option>
            }
        </select>
    </input-wrap>

    @if (info) {
    <ul class="block m-t-3 m-b">
        @for (item of infoItems; track trackByInfoItemTitleValue(index, item); let even = $even; let index = $index) {
        <li class="flex flex-justify-between p-a-2"
            [class.bg-col-5]="even">
            <span class="s2 no-wrap">
                {{item.title}}
            </span>
            @if (!item.isPrice) {
            <span class="p2 right"
                  [ngClass]="{'w-7-s' : index === 0}">
                {{item.value}}
            </span>
            }
            @if (item.isPrice) {
            <price class="p2 right"
                   [value]="asNumber(item.value)"
                   [precision]="2"></price>
            }
        </li>
        }
    </ul>
    <p class="p2 col-12 m-t m-b"
       *iCms="'footer' of content; skipEmpty: true"></p>
    }
</div>
